export const CUSTOMER_API_URL = 'https://subscription-pr.huckleberry-inc.com/subscription-pr/asia-northeast1/customerApi';
export const FIREBASE_API_KEY = 'AIzaSyAq9gRKXcRhFs1B6Bn_-WFJMsYWTqxbiSo';
export const FIREBASE_PROJECT_ID = 'subscription-pr';
export const STOREFRONT_API_KEY = process.env.REACT_APP_STOREFRONT_API_KEY;
export const STOREFRONT_API_URL = process.env.REACT_APP_STOREFRONT_API_URL;

export const billingPolicyIntervals = {
  DAY: '日毎',
  WEEK: '週間毎',
  MONTH: 'ヶ月毎',
  YEAR: '年毎',
};

export const BOX_PLAN_PREFIX = '[BOX]';
